var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLotus = function SvgLotus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 512 512",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.488 353.251c-29.868-29.883-69.595-46.333-111.841-46.348-34.279 0-66.588 11.331-93.633 31.377-61.864-45.657-149.431-41.063-205.422 14.929L6.296 397.623l10.547 10.547c30.835 30.835 71.338 46.26 111.841 46.26 40.518 0 81.035-14.35 111.87-45.185l15.527-15.548 15.527 15.547c30.85 30.835 71.353 45.185 111.855 45.185 40.518 0 81.021-15.425 111.855-46.26l10.605-10.605z",
    fill: "#4cb65c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M383.383 454.472c40.518 0 81.021-15.425 111.855-46.26l10.605-10.605-44.355-44.355c-29.868-29.883-69.595-46.333-111.841-46.348-34.279 0-66.588 11.331-93.633 31.377v55.459l15.527 15.547c30.851 30.835 71.354 45.185 111.857 45.185z",
    fill: "#4cb65c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m168.417 384.203-8.525-4.351C66.295 332.03 68.851 202.404 95.395 100.565c88.435 24.294 193.766 77.48 208.184 168.003l1.392 8.716z",
    fill: "#a67ac8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M381.962 359.667 207.514 271l2.681-11.455c19.929-85.379 121.437-135.653 206.411-158.979 21.342 81.539 29.038 188.703-26.953 250.591z",
    fill: "#a67ac8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M436 183.739c-59.399 0-115.869 27.422-152.725 73.755L256 255.744l-30.264-1.941C188.529 209.184 134.345 183.739 76 183.739H0v15c0 107.52 88.48 195 196 195h120c107.52 0 196-87.48 196-195v-15z",
    fill: "#b38cd2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M512 198.739v-15h-76c-59.399 0-115.869 27.422-152.725 73.755L256 255.744V393.74h60c107.52 0 196-87.48 196-195.001z",
    fill: "#b38cd2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M266.605 68.134 256 57.528l-10.605 10.605C241.542 71.986 151 163.627 151 258.739c0 117.466 65.786 135 105 135s105-17.534 105-135c0-95.112-90.542-186.753-94.395-190.605z",
    fill: "#C7A6E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M361 258.739c0-95.112-90.542-186.753-94.395-190.605L256 57.528v336.211c39.214 0 105-17.534 105-135z",
    fill: "#C7A6E3"
  })));
};
export default SvgLotus;